module.exports = "//d274d294w9cx2v.cloudfront.net/4070be16fa88e845dea5849a0310a4f1d8ba169f/images/photo-single.png";